import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../../../Global/Base/Rights/RightTypes";
import { DropDownMenuItem } from "../../../../../UI.Controls/DropDownMenu/DropDownMenuItem";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { ComboBox } from "../../../Controls/ComboBox";

export class DropDownMenuComboItem extends DropDownMenuItem {
    private _required: boolean = false;

    public isClickable: boolean = false;

    public combobox: ComboBox;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    public get required(): boolean {
        return this._required;
    }

    public set required(value: boolean) {
        this._required = value;
        if (this.combobox) {
            this.combobox.required = value;
        }
        this._captionElement?.classList.toggle("Required", this.required);
    }

    protected override _constructor(): void {
        super._constructor();
        this.visible = true;
    }

    protected override _createElement(): void {
        this.classList.add("DropDownMenuItem", "ComboboxItem");
        this._captionElement = document.createElement("div");
        this._captionElement.classList.add("Caption");
        this._captionElement.classList.toggle("Required", this.required);
        const comboElement = document.createElement("div");
        this.combobox = new ComboBox({ element: comboElement, originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });
        this.combobox.initialize().then(() => {
            this.combobox.required = this.required;
            this.combobox.isEditing = true;
        });
        this.appendChild(this._captionElement);
        this.appendChild(comboElement);

        this._setListener();
    }

    public addItemsToCombobox(list: { desc: string; code: string }[]): void {
        const sel = this.combobox.element.getElementsByTagName("select")[0];
        sel.removeChild(sel.firstElementChild);

        const emptyValueOptions = list.find(item => !item.code);
        this._captionElement.classList.toggle("Required", !!emptyValueOptions);
        this.combobox.element.classList.toggle("Required", !!emptyValueOptions);

        for (let i = 0; i < list.length; i++) {
            const opt = document.createElement("option");
            opt.textContent = list[i].desc;
            opt.setAttribute("data-format", list[i].code);
            opt.value = list[i].code;
            sel.appendChild(opt);
        }
    }

    protected override _setListener(): void {
        this._eventsController.addListener(this, "click", (event: MouseEvent) => {
            if (event.button === 0) {
                event.stopImmediatePropagation();
            }
        });

        // Dochází k nechtěnému zavření celého dropDownu po kliknutí v selectu
        this._eventsController.addListener(this.combobox.innerElement, "click", (event: MouseEvent) => {
            event.stopImmediatePropagation();
        });
    }

    public override dispose(): void {
        this.combobox?.dispose();
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownMenuComboItem", DropDownMenuComboItem);
